import { Button, Form, Input, Radio } from "antd";
import { useNavigate } from "react-router-dom";
import { Technic } from "../../generated/graphql";

type TechnicFormProps = {
  technic?: Partial<Technic>;
  loading: boolean;
  showButtons?: boolean;
  onSave: (name: string, type: string) => void;
};

export default function TechnicForm({
  technic,
  loading,
  showButtons = true,
  onSave,
}: TechnicFormProps) {
  const navigate = useNavigate();
  const onFinish = ({ name, type }: any) => {
    onSave(name, type);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      id="TechnicForm"
      name="basic"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 16 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="Name"
        name="name"
        initialValue={technic?.name}
        rules={[
          { required: true, message: "Please input a name for the technic !" },
        ]}
      >
        <Input autoFocus />
      </Form.Item>

      <Form.Item
        label="Type"
        name="type"
        initialValue={technic?.type}
        rules={[{ required: true, message: "Please pick a type !" }]}
      >
        <Radio.Group>
          <Radio.Button value="raw">Raw</Radio.Button>
          <Radio.Button value="cook">Cook</Radio.Button>
        </Radio.Group>
      </Form.Item>

      {showButtons && (
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {!!technic ? "Update" : "Add"}
          </Button>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
        </Form.Item>
      )}
    </Form>
  );
}
